import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { useQuery, useMutation } from "@tanstack/react-query";
import Api from "utils/api/Api";
import { toast } from 'react-toastify';

export const BookDebateTopicRequestForm = () => {
    const { isbn } = useParams();
    const detailBook = useSelector(state => state.detailBook);
    const auth = useSelector(state => state.auth);
    const [content, setContent] = useState('');

    // 
    const { data: topicRequest, isLoading, isError } = useQuery({
        queryKey: ['debate/topic/request', isbn],
        queryFn: () => {
            if (!auth.authenticated) return;
            return Api.get(`/api/debate/topic/request/${isbn}`)
        }
    })

    useEffect(() => {
        setContent(topicRequest?.data || '');
    }, [topicRequest]);


    //
    const debateTopicRequestMutate = useMutation({
        mutationFn: (data) => Api.post('/api/debate/topic/request/store', data),
        onSuccess: (res) => {
            toast.success("토론 주제를 신청 했습니다.");
        },
        onError: (err) => {
            toast.error("토론 주제를 신청에 실패했습니다.");
        }
    });

    const onStoreDebateTopic = (e) => {
        e.preventDefault();
        if ([...content.replaceAll(/\n/gi, '')].length < 10) return toast.error("10자 이상 작성해주세요.");
        if (debateTopicRequestMutate.isPending) return;
        debateTopicRequestMutate.mutate({ isbn, content });
    }

    if (!auth.authenticated) return null;
    if (detailBook?.topicClosed) return null;
    if (isLoading || isError) return null;

    return (
        <div className="topicRequestFormContainer">
            <div>
                <img className="title_pc" src={`${process.env.PUBLIC_URL}/static/images/debate/debate_request_form_title_pc.png`} alt="응답하라 독서토론 주제신청" />
                <img className="title_mo" src={`${process.env.PUBLIC_URL}/static/images/debate/debate_request_form_title_mo.png`} alt="응답하라 독서토론 주제신청" />
                <p className="desc">독서길라잡이 친구들과 재미있게 토론할 수 있는 응답하라 독서 토론 주제를 신청해보세요!</p>
                <div className="send_area">
                    <form onSubmit={onStoreDebateTopic}>
                        <input type="text" placeholder="📧 독서 토론 주제를 작성하여 신청해보세요." rows="3" name="content" value={content} onChange={(e) => setContent(e.target.value)} />
                        <button type="submit"></button>
                    </form>
                </div>
            </div>
        </div>
    )
}